<template>
  <div style="position: relative; font-size: 16px; color: #4a5568; user-select: none;">
    <div style="font-size:12px" :class="{ 'valid': !valid }">{{title}} <font color="red" v-if="required">※</font></div>
    <input-box
      :show="show"
      :value="value"
      :range="range"
      :dateFormat="dateFormat"
      @click="isEnd; onToggle($event);"
      @clear="onClear($event, { isEnd: false })"
      :end="false"
      :is-end="isEnd"
      :only-date="onlyDate"
      :valid="valid"
    >
    </input-box>
    <input-box
      v-if="range"
      :show="show"
      :value="value"
      :range="range"
      :dateFormat="dateFormat"
      @click="isEnd = true; onToggle($event);"
      @clear="onClear($event, { isEnd: true })"
      :end="true"
      :is-end="isEnd"
      :only-date="onlyDate"
      :valid="valid"
    >
    </input-box>
    <date-time-picker-window
      v-if="show"
      :value="value"
      :range="range"
      :right="right"
      :only-date="onlyDate"
      @change="onChange"
      @close="onClose"
      :is-end="isEnd"
    >
    </date-time-picker-window>
  </div>
</template>

<script>
import InputBox from './InputBox'
import DateTimePickerWindow from './DateTimePickerWindow'

export default {
  components: {
    InputBox,
    DateTimePickerWindow
  },
  model: {
    event: 'change'
  },
  props: {
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: false,
      default: null
    },
    value: {
      type: [String, Object],
      required: false,
      default: null
    },
    right: {
      type: Boolean,
      required: false,
      default: false
    },
    range: {
      type: Boolean,
      required: false,
      default: false
    },
    onlyDate: {
      type: Boolean,
      required: false,
      default: false
    },
    dateFormat: {
      type: String,
      required: false,
      default: 'YYYY年M月D日 H:mm'
    },
    valid: {
      type: Boolean,
      required: false,
      default: true
    },
    end: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: () => ({
    show: false,
    isEnd: false
  }),
  mounted() {
    this.isEnd = this.end
  },
  methods: {
    onToggle() {
      this.show = !this.show
    },
    onChange(event) {
      this.$emit('change', event)
    },
    onClear(event, payload) {
      if (this.range) {
        const { isEnd } = payload
        const { value } = this

        const obj = { start: value.start, end: value.end }
        obj[isEnd ? 'end' : 'start'] = null

        this.$emit('change', obj)
      } else {
        this.$emit('change', null)
      }

      this.show = false
    },
    onClose() {
      this.show = false
    }
  }
}
</script>

<style scoped>
.valid {
  color: #b71c1c;
}
</style>
